import { useReducer } from 'react';

import storeReducer, { IState, StoreAction, initialState } from '../ducks/stores';

export const useStoresReducer = (): IState & {
  storeLocatorDispatch: StoreAction;
} => {
  const [
    {
      storesNearby,
      storesFavs,
      storesRecent,
      searchingFavs,
      searchingNearby,
      searchingRecent,
      storesById,
      ...state
    },
    storeLocatorDispatch,
  ] = useReducer(storeReducer, initialState);

  return {
    ...state,
    searchingFavs,
    searchingNearby,
    searchingRecent,
    rawIsSearching: searchingFavs || searchingNearby || searchingRecent,
    storeLocatorDispatch,
    storesFavs,
    storesNearby,
    storesRecent,
    storesById,
  };
};
